<div
  *ngIf="currentAlert"
  [@slideDown]="animationState"
  class="water-leak-banner"
  [ngClass]="{
    'banner-warning': currentAlert.state === 'awaiting_response',
    'banner-danger': currentAlert.state === 'shutoff',
    'banner-info': currentAlert.state === 'persistent_wet'
  }"
>
  <!-- Awaiting Response -->
  <ng-container *ngIf="currentAlert.state === 'awaiting_response'">
    <div class="banner-content">
      <div class="banner-text">
        <div class="banner-title">Water Detected</div>
        <div class="banner-message">
          Water has been detected at <strong>{{ currentAlert.sensorName }}</strong>.
          Are you experiencing a leak?
        </div>
        <div class="banner-timer">Water will automatically shut off in 10 minutes if no response</div>
      </div>
    </div>
    <div class="banner-actions">
      <button class="btn-yes" (click)="onYes()">Yes, this is a leak</button>
      <button class="btn-no" (click)="onNo()">No leak</button>
    </div>
  </ng-container>

  <!-- Water Shut Off -->
  <ng-container *ngIf="currentAlert.state === 'shutoff'">
    <div class="banner-content">
      <div class="banner-text">
        <div class="banner-title">Water Has Been Shut Off</div>
        <div class="banner-message">
          Water has been shut off due to a leak detected at
          <strong>{{ currentAlert.sensorName }}</strong>.
          Property management has been notified.
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Persistent Wet (after NO response) -->
  <ng-container *ngIf="currentAlert.state === 'persistent_wet'">
    <div class="banner-content">
      <div class="banner-text">
        <div class="banner-title">Water Still Detected</div>
        <div class="banner-message">
          Water is still being detected at
          <strong>{{ currentAlert.sensorName }}</strong>.
        </div>
      </div>
    </div>
  </ng-container>
</div>
